import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Row = ({ text, value, icon, valueBgColorCondition }) => (
  <div className="flex text-white flex-row items-center text-xl justify-between w-full py-2">
    <div className="flex flex-row items-center text-xl">
      {icon && <i className={"p-2 " + icon}></i>}
      {text}
    </div>
    <div className={valueBgColorCondition && valueBgColorCondition}>
      {value}
    </div>
  </div>
);

const ProductView = ({ data }) => {
  const [open, setOpen] = useState(0);

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
  };

  return (
    <div
      style={{ height: "100vh", overflowY: "scroll", paddingBottom: 50 }}
      className="flex flex-col  p-3 h-full overflow-scroll w-full"
    >
      <div className="flex flex-row w-full justify-between items-start ">
        <div
          style={{ boxShadow: "var(--box-shadow)" }}
          className=" flex flex-col  w-full  px-3"
        >
          <div className="text-xl w-full bg-green-500 rounded p-2 bx bxs-diamond">
            {data?.title}
            <i className="text-xs m-2 ">({data?.category})</i>
          </div>
          <div className="flex flex-col  text-xl ">
            <div
              style={{ width: "50vw", height: "30vh", padding: "200px 10px" }}
              className="p-5 flex flex-grow  justify-center items-center"
            >
              {data?.images.length !== 0 ? (
                data?.images.map((x) => (
                  <img style={{ height: "30vh" }} src={x} alt="gemImg" />
                ))
              ) : (
                <img
                  style={{ height: "30vh" }}
                  src="https://www.gemsngems.com/wp-content/uploads/2019/05/placeholder_2-300x300.jpg"
                  alt="gem"
                  className=""
                />
              )}
            </div>

            <div className="flex w-full justify-evenly">
              <div className="flex flex-col w-full justify-evenly p-3 border-spacing-10 border-2 border-cyan-200">
                <Row icon={"bx bx-pin"} text={"Title"} value={data?.title} />
                <Row
                  icon={"bx bx-pin"}
                  text={"Product ID "}
                  value={"#" + data?.productId}
                />
                <Row
                  icon={"bx bx-pin"}
                  text={"Piece "}
                  value={"#" + data?.buyPiece}
                  valueBgColorCondition={"bg-green-600 p-2 rounded-full"}
                />
                <Row
                  icon={"bx bx-category"}
                  text={"Category "}
                  value={data?.category}
                />

                <Row
                  icon={"bx bx-hourglass"}
                  text={"exportMainCategory "}
                  value={data?.exportMainCategory}
                />
                <Row
                  icon={"bx bx-hourglass"}
                  text={"exportWeightRange "}
                  value={data?.exportWeightRange}
                  valueBgColorCondition={
                    Number(data?.weight) >= 3
                      ? "bg-green-600 p-2 rounded-full"
                      : "bg-red-600 p-2 rounded-full"
                  }
                />
                <Row
                  icon={"bx bx-hourglass"}
                  text={"Weight "}
                  value={data?.weight + "ct"}
                />
                <Row
                  icon={"bx bx-hourglass"}
                  text={"Shape "}
                  value={data?.shape}
                />

                <Row
                  icon={"bx bx-show-alt"}
                  text={"Clarity "}
                  value={data?.clarity}
                />
                <Row
                  icon={"bx bx-package"}
                  text={"Storage Box Name"}
                  value={data?.storageBoxName}
                />
                <Row
                  icon={"bx bx-package"}
                  text={"Storage Box Slot"}
                  value={data?.storageSlot}
                />
              </div>
              <div className="flex flex-col w-full justify-evenly p-3 border-2 border-cyan-200">
                <Row
                  icon={"bx bx-bong"}
                  text={"Treatment Type "}
                  value={data?.treatment_type}
                />
                <Row
                  icon={"bx bx-current-location"}
                  text={"Origin "}
                  value={data?.origin}
                />
                <Row
                  icon={"bx bx-hourglass"}
                  text={"exchangeRate "}
                  value={data?.exchangeRate}
                />
                <Row
                  icon={"bx bx-money"}
                  text={"Buy Price"}
                  value={
                    Number(Number(data?.buyPrice).toFixed(2)).toLocaleString() +
                    " " +
                    data?.buyCurrency
                  }
                />
                <Row
                  icon={"bx bx-hourglass"}
                  text={"priceVariant "}
                  value={data?.priceVariant === "true" ? "ON": "OFF"}
                  valueBgColorCondition={
                    data?.priceVariant === "true"
                      ? "bg-green-600 p-2 rounded-full"
                      : "rounded-full bg-red-600 p-2"
                  }
                />
                <Row
                  icon={"bx bx-money"}
                  text={"Sell Price Local"}
                  value={
                    Number(
                      Number(data?.sellPriceLocal || 0).toFixed(2)
                    ).toLocaleString() +
                    " " +
                    data?.sellLocalCurrency
                  }
                />
                <Row
                  icon={"bx bx-money"}
                  text={"Sell Price Local 2"}
                  value={
                    Number(
                      Number(data?.sellPriceLocal2 || 0).toFixed(2)
                    ).toLocaleString() +
                    " " +
                    data?.sellLocalCurrency
                  }
                />
                <Row
                  icon={"bx bx-money"}
                  text={"Sell Price Foreigners "}
                  value={
                    Number(
                      Number(data?.sellPriceForeigners || 0).toFixed(2)
                    ).toLocaleString() +
                    " " +
                    data?.sellForeignersCurrency
                  }
                />
                <Row
                  icon={"bx bx-money"}
                  text={"Sell Price Foreigners 2"}
                  value={
                    Number(
                      Number(data?.sellPriceForeigners2 || 0).toFixed(2)
                    ).toLocaleString() +
                    " " +
                    data?.sellForeignersCurrency
                  }
                />
                {data?.isSold && (
                  <Row
                    icon={"bx bx-money"}
                    text={"Item Sold"}
                    value={data?.invoiceNumber}
                  />
                )}
              </div>
            </div>

            {/* <Row icon={"bx bx-hourglass"} text={"sellPriceLocal2 "} value={data?.sellPriceLocal2} />
            <Row icon={"bx bx-hourglass"} text={"sellPriceForeigners2 "} value={data?.sellPriceForeigners2} /> */}
          </div>
        </div>
      </div>
      <div className="flex flex-col w-full my-3">
        {data?.supplier && data?.supplier.length !== 0 && (
          <Accordion
            style={{ backgroundColor: "rgb(34 197 97)" }}
            className="bg-green-500 flex flex-col w-full"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography
                style={{ color: "white" }}
                variant="subtitle1"
                className="bx bx-user-pin"
              >
                Supplier
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="bg-zinc-400">
              <div className="flex justify-between items-center w-8/12">
                <div className="flex">
                  <img
                    src="https://img.icons8.com/color/344/customer-skin-type-7.png"
                    alt=""
                  />
                </div>
                <div className="flex flex-col">
                  <div className="">
                    Name : {data?.supplier[0].firstName}{" "}
                    {data?.supplier[0].lastName}
                  </div>
                  <div className="">
                    Address : {data?.supplier[0].homeAddress},{" "}
                    {data?.supplier[0].city}, {data?.supplier[0].country}
                  </div>
                  <div className="">
                    Business Address : {data?.supplier[0].businessAddress},
                  </div>
                  <div className="">Mobile : {data?.supplier[0].mobile}</div>
                  <div className="">Email : {data?.supplier[0].email}</div>
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        )}
        {data?.customer &&
          data?.customer.length !== 0 &&
          data?.customer[0] !== "" && (
            <Accordion
              style={{ backgroundColor: "rgb(34 197 97)" }}
              className="bg-green-500 flex flex-col w-full my-2"
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography
                  style={{ color: "white" }}
                  variant="subtitle1"
                  className="flex items-center justify-evenly bx bx-user-pin"
                >
                  Customer
                </Typography>
              </AccordionSummary>
              <AccordionDetails className="bg-zinc-400">
                <div className="flex justify-between items-center w-8/12">
                  <div className="flex">
                    <img
                      src="https://img.icons8.com/color/344/customer-skin-type-7.png"
                      alt=""
                    />
                  </div>
                  <div className="flex flex-col">
                    <div className="">
                      Name : {data?.customer[0].firstName}{" "}
                      {data?.customer[0].lastName}
                    </div>
                    <div className="">
                      Address : {data?.customer[0].homeAddress},{" "}
                      {data?.customer[0].city}, {data?.customer[0].country}
                    </div>
                    <div className="">Mobile : {data?.customer[0].mobile}</div>
                    <div className="">Email : {data?.customer[0].email}</div>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          )}
      </div>
    </div>
  );
};

export default ProductView;
